import { CourseMaterial } from "routes/home/my-courses/index/coursesLoader";
import styles from "./DisplayNotes.module.scss";
import CourseNotesContent from "../../../common/courses/CourseNotesContent.tsx";
import clsx from "clsx";

export default function DisplayNotes({
  displayNotes,
  className,
}: Pick<CourseMaterial, "displayNotes"> & { className?: string }) {
  return (
    <div className={clsx(styles.displayNotes, className)}>
      <CourseNotesContent text={displayNotes} />
    </div>
  );
}
